// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3qLif","footer":"ModalError_footer__1Z0sE"};